// ./components/Button.ts
import { ComponentStyleConfig } from '@chakra-ui/react';

export const Button: ComponentStyleConfig = {
  variants: {
    emphasis: {
      bg: 'primary.500',
      color: 'white',
      fontWeight: 'semibold',
      transition: 'all 0.2s ease',
      _hover: {
        bg: 'primary.600',
      },
      _active: {
        bg: 'primary.700',
        transform: 'translateY(0)',
      },
      _focusVisible: {
        boxShadow: 'outline',
      },
      _disabled: {
        bg: 'gray.300',
        cursor: 'not-allowed',
        opacity: 0.6,
      },
    },
  },
};
